import React, { useState } from "react";
import Images from "../../Images";
import { motion } from "framer-motion";

export const Features = () => {
  const [hoveredIndex, setHoveredIndex] = useState(0);

  const category_imgs = [
    Images.category_img,
    Images.category_img_two,
    Images.category_img_three,
  ];

  const contents = [
    {
      title: "Post Exclusive Deals In One Place",
      description:
        "A centralized platform, making it easy for customers to discover and redeem your offers",
    },
    {
      title: "Boost Your Sales, Reach More Customers",
      description:
        "Broadcast your discounted products and attract a broader customer ready to shop and save more!",
    },
    {
      title: "Your Hub for Maximum Visibility",
      description:
        "Engage customers across all categories and drive instant redemptions with ease!",
    },
  ];

  return (
    <div className="bg-[#FBDDD3] lg:rounded-t-[6rem] lg:rounded-b-[6rem]">
      <div className="flex max-w-[1200px] mx-auto flex-col lg:flex-row w-full items-start h-auto relative overflow-hidden p-6 lg:p-12 justify-between gap-8">
        <div className="w-full lg:w-[50%] h-[450px] flex items-center justify-center relative">
          {category_imgs.map((img, index) => (
            <motion.img
              key={index}
              src={img}
              alt={`Category ${index + 1}`}
              className="object-contain absolute top-0 left-0 w-full h-full"
              initial={{ opacity: 0 }}
              animate={{ opacity: hoveredIndex === index ? 1 : 0 }}
              transition={{ duration: 0.5 }}
            />
          ))}
        </div>

        <div className="flex flex-col w-full lg:w-[50%] gap-y-6">
          {contents.map((content, index) => {
            const { title, description } = content;
            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(0)}
                className={`flex hover:scale-105 transition duration-300 ease-in-out flex-col lg:flex-row items-start lg:items-center w-full bg-white shadow-md rounded-lg p-4 border-l-[5px] ${
                  index === 0
                    ? "border-[#FF6C6C]"
                    : index === 1
                    ? "border-[#7DDB6A]"
                    : "border-[#FF9054]"
                }`}
              >
                <div className="flex flex-col">
                  <h2 className="mb-2 text-lg font-medium text-black capitalize lg:text-xl">
                    {title}
                  </h2>
                  <p className="text-sm text-gray-500 lg:text-base">
                    {description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Features;
